// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j2tO","left":"styles_left__3cLdU","desktopActions":"styles_desktopActions__3NHL2","title":"styles_title__FHZ_2"};